import { GetRequestOptions } from "./grunt";

const getPth=process.env.REACT_APP_GRUNT_API+"/pasmina";
const StatusOk={status:200};




const getPasmine=async()=>{
    let _pth=getPth;
    try {
        const r = await fetch(_pth, GetRequestOptions("GET"));    
        const res=await r.json();
        if (r.status===200) {
            StatusOk.res=res;
            return StatusOk;
        } else {
            return res;               
        }
        
    } catch (ex) {
        return {code: ex.code, message: "Greška kod dohvata podataka. " + ex.message, status: ex.status, name: ex.name};
    }
}

const getPasmineKlijenta=async()=>{
    let _pth=getPth+"/pasmine_klijenta";
    try {
        const r = await fetch(_pth, GetRequestOptions("GET"));    
        const res=await r.json();
        if (r.status===200) {
            StatusOk.res=res;
            return StatusOk;
        } else {
            return res;               
        }
        
    } catch (ex) {
        return {code: ex.code, message: "Greška kod dohvata podataka. " + ex.message, status: ex.status, name: ex.name};
    }
}


export {getPasmine,getPasmineKlijenta};